import { render, staticRenderFns } from "./myProgress.vue?vue&type=template&id=24dab977&scoped=true"
import script from "./myProgress.vue?vue&type=script&lang=js"
export * from "./myProgress.vue?vue&type=script&lang=js"
import style0 from "./myProgress.vue?vue&type=style&index=0&id=24dab977&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dab977",
  null
  
)

export default component.exports